import React from "react";
import { Row } from "react-bootstrap";
import "../../assets/styles/grid-menu.scss";
import { routesAdmin } from "../../router";
import GridItem from "./parts/GridItem";
import { IconCheveronLeft, IconCheveronRight } from "../../icons/Icon";

const GridMenu = ({ isCollapsed, onToggle }) => {
  const menuItems = routesAdmin.filter((r) => r.isMenu);

  return (
    <div className="grid-menu-wrapper">
      <button 
        className="grid-menu-toggle" 
        onClick={onToggle}
        aria-label={isCollapsed ? "Expand menu" : "Collapse menu"}
      >
        {isCollapsed ? (
          <IconCheveronRight color="#33383F" />
        ) : (
          <IconCheveronLeft color="#33383F" />
        )}
      </button>
      {!isCollapsed && (
        <Row className="grid-menu">
          {menuItems.map((route) => (
            <GridItem key={route.id} route={route} />
          ))}
        </Row>
      )}
    </div>
  );
};

export default GridMenu;
